module.exports = __webpack_public_path__ + "static/img/tile_ocean.574efdee.png";